import { eventManager } from "@foretagsplatsen/yaem";
import { widget } from "@foretagsplatsen/widgetjs";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner

/**
 * `loadingWidget` listens for `sync` events to display/hide a
 * loading notification. Only one loadingWidget should be rendered
 * at a time.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} loadingWidget
 */
function loadingWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);
	let ongoingRequests = 0;

	// Listen to sync events
	eventManager.at("sync").register("loading", () => {
		ongoingRequests++;
		if (ongoingRequests) {
			my.show();
		}
	});

	eventManager.at("sync").register("loaded", () => {
		ongoingRequests--;
		if (!ongoingRequests) {
			my.hide();
		}
	});

	// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
	my.spinner = new OldSpinnerWidget({
		size: 48,
		visible: false,
	});

	that.renderContentOn = function (html) {
		html.div({ id: "loading" }, my.spinner);
	};

	my.show = function () {
		my.spinner.show();
	};

	my.hide = function () {
		my.spinner.hide();
	};

	return that;
}

export default loadingWidget;
